import { utcToZonedTime, format } from "date-fns-tz";

const formatToUTC = (date: Date, dateFormat: string) => {
  const rawDate = new Date(date);
  const zonedDate = utcToZonedTime(rawDate, "UTC");
  return format(zonedDate, dateFormat, { timeZone: "UTC" });
};

export default formatToUTC;
